import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAssessmentStore = defineStore(
  'assessment',
  () => {
    const basicInfo = ref({
      id: '',
      assessmentId: '',
      customerId: '',
      assessmentDate: '',
      assessmentReason: '',
      c2: '',
      c3: '',
      c4: '',
      c11: '',
      c12: '',
      c13: '',
      c14: '',
      informantSigned: '',
      assessorSignedAt: '',
      notes: '',
    })

    const riskEvents = ref({
      iacAssessmentSuicide: '',
      iacAssessmentChoking: '',
      iacAssessmentBeLost: '',
      iacAssessmentFall: '',
    })

    // 以字典code为key存分值
    const dailyScores = ref({})
    const mentalScores = ref({})
    const perceptionScores = ref({})
    const socialScores = ref({})

    const setBasicInfo = (info = {}) => {
      basicInfo.value = { ...basicInfo.value, ...info }
    }

    const setRiskEvents = (events = {}) => {
      riskEvents.value = { ...riskEvents.value, ...events }
    }

    const setDailyScores = (scores = {}) => {
      dailyScores.value = { ...scores }
    }

    const setMentalScores = (scores = {}) => {
      mentalScores.value = { ...scores }
    }

    const setPerceptionScores = (scores = {}) => {
      perceptionScores.value = { ...scores }
    }

    const setSocialScores = (scores = {}) => {
      socialScores.value = { ...scores }
    }

    return {
      basicInfo,
      riskEvents,
      dailyScores,
      mentalScores,
      perceptionScores,
      socialScores,
      setBasicInfo,
      setRiskEvents,
      setDailyScores,
      setMentalScores,
      setPerceptionScores,
      setSocialScores,
    }
  },
  {
    persist: true,
  },
)
